"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import DateFormat from "@/framework/timeformatter";
import API from "@ym-framework/api-utils";
import {
  AccountNumberModel
} from "@/models/costModels/AccountCoin.model";
let InviteGift = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v7/invite-givens")
    );
    this.accountCoins = new AccountNumberModel();
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        this.gridController.query.filter = null;
        yield this.gridController.search();
        let response = yield API.get(
          `api://base.auth/api/v7/client/extenstion`
        );
        this.accountCoins = response.data;
      } catch (error) {
      }
    });
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatter(DateFormat.check(time));
    }
  }
  format_day(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatterDay(DateFormat.check(time));
    }
  }
};
InviteGift = __decorateClass([
  Component({
    components: {
      UiGrid
    }
  })
], InviteGift);
export {
  InviteGift as default
};
